export enum CheckTicketType {
  betTicket,
  jackpot,
}
